module.exports = __webpack_public_path__ + "img/11.c5ade4ba.jpeg";